import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Input, Button } from 'antd'

import ConfirmButton from '@components/ConfirmButton'

import { paramGroups } from '@services/api'

@inject((store: any) => {
    const { popupStore, paramGroupsStore, parametersStore } = store
    return { popupStore, paramGroupsStore, parametersStore }
})
@observer
export default class ParamGroupPopup extends Component<any, any> {
    state: any = {
        values: {},
        errors: {}
    }
    setValue = (name, value) => {
        this.setState(prevState => ({ ...prevState, values: { ...prevState.values, [name]: value } }))
    }
    deleteParamGroup = async () => {
        const { id } = this.props.popupStore.info
        await paramGroups
            .deleteParamGroup(id)
            .then(res => this.updateParamGroups())
            .catch(e => this.setError('serverError', e))
    }
    closePopup = () => {
        this.setState({ values: {}, errors: {} })
        this.props.popupStore.togglePopup(false)
    }
    validate = () => {
        const { values } = this.state
        const { id } = this.props.popupStore.info
        if (id) {
            if ('name' in values && !values.name) {
                return this.setError('name', 'חובה להזין שם קבוצה')
            }
        } else {
            if (!values.name) return this.setError('name', 'חובה להזין שם קבוצה')
        }
        return true
    }
    handleSubmitParamGroup = async () => {
        const { values } = this.state
        const { id } = this.props.popupStore.info
        if (this.validate()) {
            let error = 'אירעה שגיאה בשרת'
            if (id) {
                await paramGroups
                    .updateParamGroup({ id, ...values })
                    .then(async res => this.updateParamGroups())
                    .catch(e => {
                        if (e.response.status && e.response.status === 400) {
                            error =
                                e.response.data[0].validation === 'unique'
                                    ? 'שם הקבוצה כבר קיים עליך להזין שם קבוצה ייחודי'
                                    : 'בעיית אימות שדות'
                        } else {
                            error = e
                        }
                        this.setError('serverError', error)
                    })
            } else {
                await paramGroups
                    .addParamGroup({ ...values })
                    .then(async res => this.updateParamGroups())
                    .catch(e => {
                        if (e.response.status && e.response.status === 400) {
                            error =
                                e.response.data[0].validation === 'unique'
                                    ? 'שם הקבוצה כבר קיים עליך להזין שם קבוצה ייחודי'
                                    : 'בעיית אימות שדות'
                        } else {
                            error = e
                        }
                        this.setError('serverError', error)
                    })
            }
        }
    }
    updateParamGroups = async () => {
        const { paramGroupsStore } = this.props
        await paramGroupsStore.getList()
        this.closePopup()
    }
    setError = (name, message) => {
        this.setState({ errors: { [name]: message } })
        return false
    }
    render() {
        const { popupType, info } = this.props.popupStore
        const { values, errors } = this.state

        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                {info.id ? (
                    <ConfirmButton
                        confirmed={() => this.deleteParamGroup()}
                        confirmQuestion="למחוק קבוצת פרמטרים?"
                        buttonText="מחק קבוצת פרמטרים"
                    />
                ) : (
                    ''
                )}
                <div style={{ float: 'left', display: 'inline-block' }}>
                    <Button onClick={this.closePopup}>ביטול</Button>
                    <Button type="primary" onClick={() => this.handleSubmitParamGroup()}>
                        {info.id ? 'שמור קבוצה' : 'הוסף קבוצה'}
                    </Button>
                </div>
            </div>
        )

        return (
            <Modal
                title={info.id ? 'עריכת קבוצת פרמטרים' : 'הוספת קבוצת פרמטרים'}
                visible={popupType === 'paramGroup'}
                footer={footerButtons}
                onCancel={this.closePopup}
            >
                <div>
                    <label htmlFor="param_group_name">
                        <strong>שם קבוצת הפרמטרים</strong>
                    </label>
                    {errors['serverError'] ? <div style={{ color: 'red' }}>{errors['serverError']}</div> : ''}
                    <Input
                        id="param_group_name"
                        value={'name' in values ? values.name : info.name}
                        placeholder="הזן את שם קבוצת הפרמטרים"
                        onChange={e => this.setValue('name', e.target.value)}
                    />
                    {errors['name'] ? <div style={{ color: 'red' }}>{errors['name']}</div> : ''}
                </div>
            </Modal>
        )
    }
}
